const greedyAlgorithmsLineMaps = {
  python: {
    1: { lines: [5, 6], operation: "initialize" },
    2: { lines: [8, 9], operation: "processing" },
    3: { lines: [8, 9], operation: "processing" },
    4: { lines: [8, 9], operation: "processing" },
    5: { lines: [8, 9], operation: "processing" },
    6: { lines: [8, 9], operation: "processing" },
    7: { lines: [8, 9], operation: "processing" },
    8: { lines: [11], operation: "complete" }
  },
  cpp: {
    1: { lines: [4, 5], operation: "initialize" },
    2: { lines: [7, 8], operation: "processing" },
    3: { lines: [7, 8], operation: "processing" },
    4: { lines: [7, 8], operation: "processing" },
    5: { lines: [7, 8], operation: "processing" },
    6: { lines: [7, 8], operation: "processing" },
    7: { lines: [7, 8], operation: "processing" },
    8: { lines: [11], operation: "complete" }
  },
  java: {
    1: { lines: [4, 5], operation: "initialize" },
    2: { lines: [7, 8], operation: "processing" },
    3: { lines: [7, 8], operation: "processing" },
    4: { lines: [7, 8], operation: "processing" },
    5: { lines: [7, 8], operation: "processing" },
    6: { lines: [7, 8], operation: "processing" },
    7: { lines: [7, 8], operation: "processing" },
    8: { lines: [11], operation: "complete" }
  }
};
export default greedyAlgorithmsLineMaps;